export default __webpack_public_path__ + "static/media/cp_geo_cz.3c4be964.svg";